import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'account',
  namespaced: true,
  state: {
    accounts: null,
  },
  mutations: {
    setAccounts(state, accounts) {
      state.accounts = accounts
    },
  },
  actions: {
    async addAccount({ dispatch }, account) {
      const { data } = await defaultApi.postCredentials(account)
      await dispatch('getAccounts')
      return data
    },
    async getAccounts({ commit }) {
      const { data } = await defaultApi.getCredentials()
      commit('setAccounts', data)
      return data
    },
    async updateAccount({ dispatch }, account) {
      const { data } = await defaultApi.patchCredentials(account)
      await dispatch('getAccounts')
      return data
    },
  },
}
